import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { AuthorizationCheckRequired, DSID, eventBus, PmStore } from "@/state";


const queryGetMyOrgs = gql`
 query getOrgs {
      myOrganizations {
        id
        name
      }
    }
`;

const gqlGetApplicationSettings = gql`
  query organizationApplicationSettings($organizationId: UUID!) {
    organizationApplicationSettings(organizationId: $organizationId) {
      application_fee
      auto_approve_enabled
      background_checks_enabled
      background_checks_required
      expiration_days
      reservation_restricted
    }
  }
`;


const queryGetOrganizationAccess = gql`
  query ApplicationAccounts($organizationId: UUID!, $applicationId: UUID!) {
    applicationAccounts(organizationId: $organizationId, applicationId: $applicationId) {
        first_name
        last_name
        phone_number
        id
    }
  }
`;

const mutationUpdateApplicationSettingsAppAutoApprove = gql`
  mutation updateApplicationSettingsApplicationAutoApprove ($organizationId: UUID!, $autoApprove: Boolean!){  
    updateApplicationSettingsApplicationAutoApprove(organizationId: $organizationId, autoApprove: $autoApprove)
  }
`;


const mutationUpdateApplicationSettingsApplicationDaysToExpiration = gql`
  mutation updateApplicationSettingsApplicationDaysToExpiration($organizationId: UUID!, $days: Int!){
  updateApplicationSettingsApplicationDaysToExpiration(organizationId: $organizationId, days: $days)  
}
`;




export function useOrganizationActions() {
  const state = PmStore();
  const [apiGetMyOrgs] = useLazyQuery(queryGetMyOrgs, { fetchPolicy: "network-only", });
  const [apiGetOrganizationAccess] = useLazyQuery(queryGetOrganizationAccess);
  const [apiGetOrgAppSettings] = useLazyQuery(gqlGetApplicationSettings);
  const [apiUpdateApplicationSettingsAppAutoApprove] = useMutation(mutationUpdateApplicationSettingsAppAutoApprove);
  const [apiUpdateApplicationSettingsApplicationDaysToExpiration] = useMutation(mutationUpdateApplicationSettingsApplicationDaysToExpiration);



  async function UpdateApplicationSettingsApplicationDaysToExpiration(days: number) {
    let organizationId = state?.selectedOrganization?.id;
    
    try {
      let result = await apiUpdateApplicationSettingsApplicationDaysToExpiration({ variables:  {organizationId, days}}) as any;
      return result.data.updateApplicationSettingsApplicationDaysToExpiration;
    }
    catch (error) {
        if (error?.name == "AbortError") {
          return await UpdateApplicationSettingsApplicationDaysToExpiration(days);
        }
        else {
            toast.error("Api Error, Unable to set expirataion days");
            throw error;
        }
    }
  }



  async function UpdateApplicationSettingsAppAutoApprove(autoApprove: boolean) {
    let organizationId = state?.selectedOrganization?.id;
    
    try {
      let result = await apiUpdateApplicationSettingsAppAutoApprove({ variables:  {organizationId, autoApprove}}) as any;
      return result.data.updateApplicationSettingsApplicationAutoApprove;
    }
    catch (error) {
        if (error?.name == "AbortError") {
          return await UpdateApplicationSettingsAppAutoApprove(autoApprove);
        }
        else {
            toast.error("Api Error, Unable to set auto approve flag");
            throw error;
        }
    }
  }




  async function GetOrganizationAccess() {
    let organizationId = state?.selectedOrganization?.id;
    
    try {
      let result = await apiGetOrganizationAccess({ variables:  {organizationId, applicationId: DSID}}) as any;
      return result.data.applicationAccounts ?? [];
    }
    catch (error) {
        if (error?.name == "AbortError") {
          return await GetOrganizationAccess();
        }
        else {
            toast.error("Api Error, Unable to get access details for organization");
            throw error;
        }
    }
  }





    function GetOrganizationApplicationSettings(organizationId: string) {
        if(!organizationId) throw "No organization selected";

        return new Promise(async (resolve, reject) => {
            apiGetOrgAppSettings({variables: {organizationId}})
            .then((result: any) => result?.data?.organizationApplicationSettings)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to get organization settings");
                reject(err);
            })
        })
    }

    async function GetMyOrgs() {
        try {
            const queryPromise = apiGetMyOrgs();
            queryPromise.retain?.();
            const result = await queryPromise as any;
            return result.data?.myOrganizations ?? [];
        } catch (error) {
    
          throw error;
        }
      }

    // function GetMyOrgs() {
    //     return new Promise(async (resolve, reject) => {
    //         apiGetMyOrgs()
    //         .then((result: any) => result?.data?.myOrganizations)
    //         .then((result) => resolve(result))
    //         .catch((err) => {
    //             console.error(err)
    //             reject(err);
    //         })
    //     })
    // }


    
    return {
        GetMyOrgs,
        GetOrganizationApplicationSettings,
        GetOrganizationAccess,
        UpdateApplicationSettingsAppAutoApprove,
        UpdateApplicationSettingsApplicationDaysToExpiration
    };
}




